import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
import { isGlobalNavAcademyMode } from '../../../utils/navEnviro';
import { LoadTrialBanner } from './LoadTrialBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrialBannerMaybe = () => {
  const gates = useAppSelector(selectGates);
  const isUngatedToHiCTrialBannerNC = gates && gates.includes('HiC:TrialBannerNC');
  const isOnAcademyPage = isGlobalNavAcademyMode();
  if (!isUngatedToHiCTrialBannerNC || isOnAcademyPage) {
    return null;
  }
  return /*#__PURE__*/_jsx(LoadTrialBanner, {});
};